module.exports = __webpack_public_path__ + "static/media/PDF_68.4184730f.pdf";